import { render } from "./ScansioniCollo.vue?vue&type=template&id=58a4dc90"
import script from "./ScansioniCollo.vue?vue&type=script&lang=js"
export * from "./ScansioniCollo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__